import { LockOutlined, MailOutlined } from '@ant-design/icons';

export const THEMES = {
  LIGHT: {
    PRIMARY_COLOR: '#D4F4fA',
    SECONDARY_COLOR: '#6699DD',
    ACCENT_COLOR: '#F6F6F6',
  },
  DARK: {
    PRIMARY_COLOR: '#293B5F',
    SECONDARY_COLOR: '#816797',
    ACCENT_COLOR: '#FFD369',
  }
};

export const LOGIN_FIELDS = [
  {
    type: 'text',
    name: 'email',
    inputProps: {
      prefix: <MailOutlined />,
      placeholder: 'Email',
    },
    rules: [
      {
        required: true,
        message: 'Please input your email!',
      },
    ],
  },
  {
    type: 'text',
    name: 'password',
    inputProps: {
      type: 'password',
      prefix: <LockOutlined />,
      placeholder: 'Password',
    },
    rules: [
      {
        required: true,
        message: 'Please input your password!',
      },
    ],
  },
  {
    type: 'checkbox',
    name: 'rememberMe',
    inputProps: {
      title: ' Remember me',
      defaultValue: true,
      style: { color: 'white' }
    }
  },
  {
    type: 'button',
    name: 'submitLogin',
    inputProps: {
      title: 'Login',
      type: 'primary',
      htmlType: 'submit',
      align: 'center'
    }
  }
];

export const PROFILE_FIELDS = [
  {
    type: 'image',
    name: 'avatar',
    inputProps: {
      accept: '.jpg,.jpeg,.png,.webp',
    },
  },
  {
    type: 'text',
    label: 'Name',
    name: 'name',
    rules: [
      {
        max: 50,
      },
    ],
  },
  {
    type: 'text',
    label: 'Email',
    name: 'email',
    inputProps: {
      disabled: true
    }
  },
  {
    type: 'switch',
    label: 'Update password?',
    name: 'shouldUpdatePassword',
    inputProps: {
      defaultValue: false,
    }
  },
  {
    type: 'text',
    label: 'Current password',
    name: 'currentPassword',
    inputProps: {
      type: 'password',
    },
  },
  {
    type: 'text',
    label: 'New password',
    name: 'newPassword',
    inputProps: {
      type: 'password',
      autoComplete: 'new-password'
    },
  },
  {
    type: 'text',
    label: 'Confirm new password',
    name: 'confirmNewPassword',
    inputProps: {
      type: 'password',
      autoComplete: 'new-password'
    },
  },
  {
    type: 'button',
    name: 'submitProfile',
    inputProps: {
      title: 'Save',
      type: 'primary',
      htmlType: 'submit',
      align: 'center'
    }
  }
];

export const ADD_COMIC_FIELDS = [
  {
    type: 'image',
    label: 'Cover',
    name: 'cover',
    inputProps: {
      accept: '.jpg,.jpeg,.png,.webp',
    },
    rules: [
      {
        required: true,
        message: 'Please select comic cover!'
      },
    ],
  },
  {
    type: 'text',
    label: 'Name',
    name: 'name',
    rules: [
      {
        required: true,
      },
      {
        max: 100,
      },
    ],
  },
  {
    type: 'text',
    label: 'Author',
    name: 'author',
    rules: [
      {
        max: 100,
      },
    ],
  },
  {
    type: 'textarea',
    label: 'Description',
    name: 'description',
    inputProps: {
      maxLength: 2000,
    },
    rules: [
      {
        max: 2000,
      },
    ],
  },
  {
    type: 'select',
    label: 'Genres',
    name: 'genres',
    inputProps: {
      mode: 'multiple',
    },
    rules: [
      {
        required: true,
        message: 'Please choose at least one genre',
      },
    ],
  },
  {
    type: 'select',
    label: 'Status',
    name: 'status',
    inputProps: {
      options: [
        { label: 'Updating', value: 'updating' },
        { label: 'Completed', value: 'completed' }
      ],
      defaultValue: 'updating',
    }
  },
];

export const ADD_CHAPTER_FIELDS = [
  {
    type: 'text',
    label: 'Chapter name',
    name: 'name',
    rules: [
      {
        required: true,
      },
    ],
  },
  {
    type: 'radio',
    name: 'inputFileType',
    inputProps: {
      options: [
        { label: 'Select files', value: 'files' },
        { label: 'Select directory', value: 'directory' }
      ],
      defaultValue: 'files',
    }
  },
  {
    name: 'clearSelectedFiles',
    type: 'button',
    inputProps: {
      title: 'Clear selected files'
    }
  },
  {
    type: 'image',
    name: 'chapterContent',
    inputProps: {
      accept: '.jpg,.jpeg,.png,.webp',
      multiple: true,
    },
    rules: [
      {
        required: true,
        message: 'Please select chapter content!',
      },
    ],
  }
];

export const EDIT_CHAPTER_FIELDS = [
  {
    type: 'text',
    label: 'Chapter name',
    name: 'name',
    rules: [
      {
        required: true,
      },
    ],
  },
  {
    type: 'switch',
    label: 'Update chapter content?',
    name: 'shouldUpdateChapterContent',
    inputProps: {
      defaultValue: false,
    }
  },
  {
    type: 'radio',
    name: 'inputFileType',
    inputProps: {
      options: [
        { label: 'Select files', value: 'files' },
        { label: 'Select directory', value: 'directory' }
      ],
      defaultValue: 'files',
    }
  },
  {
    type: 'button',
    name: 'clearSelectedFiles',
    inputProps: {
      title: 'Clear selected files'
    }
  },
  {
    type: 'image',
    name: 'chapterContent',
    inputProps: {
      accept: '.jpg,.jpeg,.png,.webp',
      multiple: true,
    }
  }
];

export const ADD_GENRE_FIELDS = [
  {
    type: 'text',
    label: 'Name',
    name: 'name',
    rules: [
      {
        required: true,
      },
    ],
  },
  {
    type: 'colorPicker',
    label: 'Color',
    name: 'color',
    inputProps: {
      defaultValue: '#fff',
      alwaysShowPicker: true
    }
  }
];

export const SETTINGS_FIELDS = [
  {
    type: 'colorPicker',
    label: 'Theme color',
    name: 'themeColor'
  }
];